import { Routes, Route } from 'react-router-dom'
import Sidebar from './components/Sidebar'
import Dashboard from './pages/Dashboard'
import Licenses from './pages/Licenses'
import Users from './pages/Users'
import PeopleForce from './pages/PeopleForce'
import GitHub from './pages/GitHub'
import Settings from './pages/Settings'
import ServiceConfig from './pages/ServiceConfig'
import Logs from './pages/Logs'
import PersonDetail from './pages/PersonDetail'

export default function App() {
  return (
    // height: '100%' (not '100vh') on purpose — html/body/#root all have height: 100% already
    // (src/index.css), so this rides that chain instead of vh units, which can render a few
    // pixels taller than the actual visible window on Windows with display scaling and clip the
    // sidebar's bottom account block.
    <div style={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
      <Sidebar />
      <main style={{ flex: 1, padding: 32, minWidth: 0, overflowY: 'auto' }}>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Licenses />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/people-force" element={<PeopleForce />} />
          <Route path="/users/github" element={<GitHub />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/services/:serviceId" element={<ServiceConfig />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/persons/:email" element={<PersonDetail />} />
        </Routes>
      </main>
    </div>
  )
}
